import { Toaster } from "@repo/ui/toaster";
import { useRouter } from "next/router";
import React, { type PropsWithChildren } from "react";

export function Pure({ children }: PropsWithChildren): React.JSX.Element {
  const router = useRouter();
  return (
    <div dir={router.locale === "fa" ? "rtl" : "ltr"}>
      {children}
      <Toaster />
    </div>
  );
}
